import { tz } from "@date-fns/tz";
import { startOfDay } from "date-fns";

export const getDateDeltaDays = (a: Date, b: Date, timeZone: string) => {
  const startOfDayA = startOfDay(a, { in: tz(timeZone) });
  const startOfDayB = startOfDay(b, { in: tz(timeZone) });
  return Math.trunc((startOfDayA.getTime() - startOfDayB.getTime()) / (1000 * 3600 * 24));
};
